<template>
  <div></div>
</template>
<script>
import { mapState } from 'vuex'
import getExternalUrl from '@/util/externalUrl'

export default {
  name: 'RedirectComponent',
  props: {
    idConfigClienteApp: {
      required: false
    },
    to: {
      required: false
    },
    newTab: {
      default: false
    }
  },
  computed: {
    ...mapState('login', ['token'])
  },
  methods: {
    onRedirect () {
      let url = getExternalUrl(this.to, { authorization: this.token, idConfigClienteApp: this.idConfigClienteApp })

      if (!url) {
        return this.$router.back()
      }

      if (this.newTab) {
        window.open(url)
        this.$router.back()
      } else {
        window.location.href = url
      }
    }
  },
  created () {
    this.onRedirect()
  }
}
</script>
